import { render, staticRenderFns } from "./TsEatinerari.vue?vue&type=template&id=609b8218&scoped=true"
import script from "./TsEatinerari.vue?vue&type=script&lang=js"
export * from "./TsEatinerari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b8218",
  null
  
)

export default component.exports